import { Menu, Dropdown, Image } from 'antd';
import React from 'react';
import moment from 'moment';
import useCalcAmount from '&/utils/customHooks/useCalcAmount';

import './ProjectCard4B.scss';

function ProjectCard(props) {
    const {
        source = {},
        clickName,
        hasMenu = true,
        toPay,
        rename,
        remove,
        onExit,
    } = props;

    const [periodChange] = useCalcAmount();

    useEffect(() => {
        periodChange(source.payCode?.period || 1);
    }, [source.payCode]);

    function handleClickMenu({ key }) {
        [rename, remove, onExit][key](source);
    }
    const { Item } = Menu;
    const { isCreate } = source;
    const menu = (
        <Menu onClick={handleClickMenu}>
            <Item key={0} disabled={[2, 3].includes(isCreate)}>
                {intl.get('base.rename')}
            </Item>
            <Item
                disabled={[2, 3].includes(isCreate) || source.status === '3'}
                key={1}>
                {intl.get('projectCard4B.disband')}
            </Item>
            <Item disabled={[1, 3].includes(isCreate)} key={2}>
                {intl.get('projectCard4B.exit')}
            </Item>
        </Menu>
    );

    const createInfoStatus = () => {
        if (!source.status) return;
        let btn = null;
        if (+source.status === 3)
            btn = (
                <div className="info-status">
                    <div className="blue-btn" onClick={() => toPay?.(source)}>
                        {intl.get('projectCard4B.toBPaid')}
                    </div>
                </div>
            );
        else if (+source.status === 4)
            return (
                <div className="info-status">
                    <div className="expired description">
                        {intl.get('projectCard4B.expired')}
                    </div>
                    <div className="blue-btn" onClick={() => toPay?.(source)}>
                        {intl.get('projectCard4B.rePaid')}
                    </div>
                </div>
            );
        else if (+source.status === 5 && +isCreate === 1)
            btn = (
                <div className="info-status">
                    <div className="expired description">
                        {moment.unix(source.expireDate).endOf('day').fromNow()}
                    </div>
                    <div className="blue-btn" onClick={() => toPay?.(source)}>
                        {intl.get('projectCard4B.renew')}
                    </div>
                </div>
            );

        return btn;
    };

    const STATUS_DICT = [
        {
            type: 'default',
            icon: 'icon-Info-Circle',
            name: intl.get('projectCard4B.notStarted'),
        },
        {
            type: 'warning',
            icon: 'icon-Info-Circle',
            name: intl.get('projectCard4B.processing'),
        },
        {
            type: 'danger',
            icon: 'icon-warning-copy',
            name: intl.get('projectCard4B.toBeAccepted'),
        },
        {
            type: 'success',
            icon: 'icon-Confirm',
            name: intl.get('projectCard4B.complete'),
        },
        {
            type: 'danger',
            icon: 'icon-warning-copy',
            name: intl.get('projectCard4B.failed'),
        },
        {
            type: 'default',
            icon: 'icon-Info-Circle',
            name: intl.get('projectCard4B.notPublish'),
        },
    ];

    const { checkStatus } = source;

    const renderStatus = (type, name, icon) => (
        <span className={`project-status status--${type}`}>
            <i className={`filled ${icon}`}></i> {name}
        </span>
    );

    const statusEl =
        source.isDelay === '1'
            ? renderStatus(
                  'danger',
                  intl.get('projectCard4B.delay'),
                  'icon-warning-copy'
              )
            : renderStatus(
                  STATUS_DICT[checkStatus]?.type,
                  STATUS_DICT[checkStatus]?.name,
                  STATUS_DICT[checkStatus]?.icon
              );

    return (
        <div className="project-card">
            {statusEl}
            <div className="project-card-body" onClick={() => clickName?.()}>
                <div className="project-image-wrap">
                    <Image
                        className={`project-image pointer ${
                            source.image ? 'has--image' : ''
                        }`}
                        preview={false}
                        src={
                            source.image ||
                            require('&/assets/img/userCenter/lbdefault.png')
                                .default
                        }
                    />
                    <div className="img-after"></div>
                    <div className="img-before"></div>
                </div>
                <div className="project-info-wrap">
                    <div className="project-info-title" title={source?.name}>
                        {source.name || '-'}
                    </div>
                    <div className="project-time-line">
                        <div className="info-label">
                            {intl.get('projectCard4B.timeLine')}
                        </div>
                        <div className="info-value">
                            {`${source.timeAt} - ${source.timeEnd}`}
                        </div>
                    </div>
                    <div className="project-schedule">
                        <div className="project-schedule-item progress">
                            <div className="value">
                                {source?.schedule?.isFinish !== null
                                    ? source?.schedule?.isFinish + '%'
                                    : '-'}
                            </div>
                            <div className="label">
                                {intl.get('projectCard4B.progress')}
                            </div>
                        </div>
                        <div className="project-schedule-item days">
                            <div className="value">
                                {source?.schedule?.duty !== null
                                    ? source?.schedule?.duty +
                                      intl.get('projectCard4B.day')
                                    : '-'}
                            </div>
                            <div className="label">
                                {intl.get('projectCard4B.dayNum')}
                            </div>
                        </div>
                        <div className="project-schedule-item reciprocal">
                            <div className="value">
                                {source?.schedule?.reciprocal !== null
                                    ? source?.schedule?.reciprocal +
                                      intl.get('projectCard4B.day')
                                    : '-'}
                            </div>
                            <div className="label">
                                {intl.get('projectCard4B.countDown')}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="project-card-foot">
                <div className="foot-info-wrap">
                    <div className="info-expire-date">
                        <div className="foot-info">
                            {intl.get('projectCard4B.expireTime')}
                            {+source.type === 6 ? (
                                <>&infin;</>
                            ) : (
                                source.expireDateMax || '-'
                            )}
                        </div>
                    </div>
                    {createInfoStatus()}
                </div>
                {hasMenu && (
                    <Dropdown overlay={menu}>
                        <i className="filled icon-more-h more-icon"></i>
                    </Dropdown>
                )}
            </div>
        </div>
    );
}

export default ProjectCard;
